// extracted by mini-css-extract-plugin
export default {"ButtonWarning":"ButtonWarnings_ButtonWarning__e9EjN","button":"ButtonWarnings_button__qaXbW","indicator":"ButtonWarnings_indicator__aO-lh","size":"ButtonWarnings_size__47Ajj"};